import { cardLibraryActions } from '../actions/card-library.actions';

const initialState = {
  beagle_card: {},
  dependent_filter_data: {},
  card_library_msg: '',
  is_update_chart_view_state:true,
  teams_default_view:{},
  update_filter:false,
  column_filter_data:[],
  search_filter_data:[],
  search_filter_obj:{},
  fallback_ui:false,
  token_fallback_ui:false,
  token_fallback_details:{},
  access_revoke_fallback_ui:false,
};

/**
 * Reducer function for managing the state of the card library.
 * 
 * Handles various actions to update different parts of the card library state,
 * such as the team card, dependent filter data, card library messages, filter columns,
 * chart view state, teams default view, column filter data, search filter data,
 * search filter object, and UI fallback states.
 *
 * @param {Object} state - The current state of the card library.
 * @param {Object} action - The action dispatched to the reducer.
 * @returns {Object} The updated state based on the action type.
 */

export const cardLibraryState = (state = initialState, action: any) => {
  switch (action.type) {
    case cardLibraryActions.SET_TEAM_CARD:
      return {...state, ...{ beagle_card: action.payload.team_card }};

    case cardLibraryActions.SET_DEPENDENT_FILTER_DATA:
      return { ...state, ...{ dependent_filter_data: action.payload.dependent_filter_data }};

    case cardLibraryActions.SET_CARD_LIBRARY_MESSAGE:
      return { ...state, ...{ card_library_msg: action.payload.card_library_msg }};

    case cardLibraryActions.UPDATE_FILTER_COLUMNS:{
      let dependent_filter_data : any = state.dependent_filter_data;
      dependent_filter_data.filter_columns = action.payload.filter_columns.slice();
      return {...state, ...{dependent_filter_data: dependent_filter_data}};
    }
    case cardLibraryActions.UPDATECHARTVIEWSTATE:
      return {...state, ...{is_update_chart_view_state:action.payload.is_update_chart_view_state}};

    case cardLibraryActions.UPDATEFILTER:
      return {...state, ...{update_filter:action.payload.update_filter}};

    case cardLibraryActions.UPDATETEAMSDEFAULTVIEW:
      return {...state, ...{teams_default_view:action.payload.teams_default_view}};
    
    case cardLibraryActions.SET_COLUMN_FILTER_DATA:
      return {...state, ...{column_filter_data:action.payload.column_filter_data}};

    case cardLibraryActions.SET_SEARCH_FILTER_DATA:
      return {...state, ...{search_filter_data:action.payload.search_filter_data}};
  
    case cardLibraryActions.UPDATE_FILTER_OBJ:
      return {...state, ...{search_filter_obj:action.payload.search_filter_obj}};

    case cardLibraryActions.SET_FALLBACK_UI:
      return {...state, ...{fallback_ui:action.payload.fallback_ui}};

    case cardLibraryActions.SET_ACCESS_FALLBACK_UI:
      return {...state, ...{access_revoke_fallback_ui:action.payload.access_revoke_fallback_ui}};

    case cardLibraryActions.SET_TOKEN_FALLBACK_UI:
      return {...state, ...{token_fallback_ui:action.payload.token_fallback_ui}};
  
    case cardLibraryActions.SET_TOKEN_FALLBACK_DETAILS:
      console.log('SET_TOKEN_FALLBACK_DETAILS', action.payload.token_fallback_details);
      return {...state, ...{token_fallback_details:action.payload.token_fallback_details}};

    default:
      return state;
  }
};
